import { TemplateActionTypes, SET_THEME } from './types';
import { Theme } from '../interfaces/Theme';

export const setTheme = (theme: Theme): TemplateActionTypes => {
  return {
    type: SET_THEME,
    payload: theme,
  };
};
